module.exports = __webpack_public_path__ + "ece301e28ac86d8de4acf3f5fd520a64.png";